import { LOAN_FILTER_OPTIONS } from '../../../../utils/status';
import { SearchFilterBar } from '@/components/base/SearchFilterBar';

interface LoanFiltersProps {
  filterStatus: string;
  onFilterChange: (v: string) => void;
  search: string;
  onSearchChange: (v: string) => void;
  filterLoai: string;
  onFilterLoaiChange: (v: string) => void;
  statusCounts?: Record<string, number>;
  typeCounts?: Record<string, number>;
}

const FILTER_OPTIONS = LOAN_FILTER_OPTIONS;

export function LoanFilters({
  filterStatus,
  onFilterChange,
  search,
  onSearchChange,
  filterLoai,
  onFilterLoaiChange,
  statusCounts = {},
  typeCounts = {},
}: LoanFiltersProps) {
  const typeLabel = (value: string, label: string) => {
    const count = typeCounts[value] ?? 0;
    return `${label}${count ? ` (${count})` : ''}`;
  };

  return (
    <div className="mb-4">
      <SearchFilterBar
        value={search}
        onChange={onSearchChange}
        placeholder="Tìm kiếm mã yêu cầu, nội dung..."
        selected={filterStatus}
        onSelect={onFilterChange}
        options={FILTER_OPTIONS.map((option) => ({
          value: option.value,
          label: option.label,
          count: statusCounts[option.value] ?? 0,
        }))}
      >
        <select
          value={filterLoai}
          onChange={(event) => onFilterLoaiChange(event.target.value)}
          className="h-11 w-full rounded-xl border border-slate-200 px-3 text-sm"
        >
          <option value="">{typeLabel('', 'Tất cả loại yêu cầu')}</option>
          <option value="Tiền">{typeLabel('Tiền', 'Tạm ứng tiền')}</option>
          <option value="Vật tư">{typeLabel('Vật tư', 'Tạm ứng vật tư')}</option>
        </select>
      </SearchFilterBar>
    </div>
  );
}
